import React from 'react'

export type NumberProps = Intl.NumberFormatOptions & { locale?: Intl.LocalesArgument, value: number }

export const Number: React.FC<NumberProps> = ({ locale = 'en-US', value, ...options}) => {
  return <>{ new Intl.NumberFormat(locale as string, options).format(value) }</>
}

export default Number